/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FishbrainExportStatusRequest
 */
export interface FishbrainExportStatusRequest {
    /**
     * 
     */
    flowRunId: string;
}

/**
 * Check if a given object implements the FishbrainExportStatusRequest interface.
 */
export function instanceOfFishbrainExportStatusRequest(value: object): value is FishbrainExportStatusRequest {
    if ((!('flowRunId' in (value as Record<string, any>)) && !('flow_run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['flowRunId'] === undefined && (value as Record<string, any>)['flow_run_id'] === undefined)) return false;
    return true;
}

export function FishbrainExportStatusRequestFromJSON(json: any): FishbrainExportStatusRequest {
    return FishbrainExportStatusRequestFromJSONTyped(json, false);
}

export function FishbrainExportStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FishbrainExportStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'flowRunId': json['flow_run_id'],
    };
}

export function FishbrainExportStatusRequestToJSON(json: any): FishbrainExportStatusRequest {
    return FishbrainExportStatusRequestToJSONTyped(json, false);
}

export function FishbrainExportStatusRequestToJSONTyped(value?: FishbrainExportStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flow_run_id': value['flowRunId'],
    };
}

